var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/autorenew_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26665 6.26695V4.66684C6.50133 4.66684 5.06666 6.10161 5.06666 7.86706C5.06666 8.40576 5.2 8.91779 5.44 9.36049L4.66133 10.1392C4.24533 9.48316 4 8.70445 4 7.86706C4 5.50957 5.90933 3.60011 8.26665 3.60011V2L10.4 4.13348L8.26665 6.26695ZM11.0933 6.37338L11.872 5.59466C12.288 6.2507 12.5333 7.02942 12.5333 7.86681C12.5333 10.2243 10.624 12.1338 8.26667 12.1338V13.7339L6.13335 11.6004L8.26667 9.46692V11.067C10.032 11.067 11.4667 9.63226 11.4667 7.86681C11.4667 7.32811 11.328 6.82141 11.0933 6.37338Z",
    fill: "#434343",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.61c3c1626fa429632f5cc16f922888b2.svg";
export { ForwardRef as ReactComponent };